export default {
  schema: {
    fields: [
      {
        model: "name",
        type: "input",
        inputType: "text",
        label: "File Group Name",
        required: true,
      },
    ],
  },
};
